export default __webpack_public_path__ + "static/vector-shape7-d937b60f3ba54b8e2856c50915991a91.png";